<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <v-form ref="addHsfp" v-model="addHsfpValid">
    <v-card-title> {{hsfp.hsfp_van_dag}} {{hsfp.hsfp_van_dat}} - {{hsfp.hsfp_tm_dag}} {{hsfp.hsfp_tm_dat }} </v-card-title>
    
    
    <v-row no-gutters>
      <v-col cols="4" class="px-1">
        <v-text-field v-model="hsfp.hsfp_inkoop" :prefix=hsfp.valu_code label="Purchase" dense type="number"></v-text-field>
      </v-col>
      <v-col cols="4" class="px-1">
        <v-text-field v-model="hsfp.hsfp_verkoop" :prefix=hsfp.valu_code label="Sales" dense type="number"></v-text-field>
      </v-col>
    </v-row>
     <v-row no-gutters>
      <v-col cols="8" class="px-2">
        <v-text-field v-model="hsfp.hsfp_advb" label="Number of days before arrival" :rules="intRules" ></v-text-field>
      </v-col> 
     </v-row>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="saveHsfp" :disabled="!addHsfpValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
    </v-form>
  </v-card>

</v-dialog>
</template>

<script>

import {bus} from "../../../../main";

export default {
  data() { 
    return {
      dialog: false,
      hsfp_encrid: null,
      hsfp: {},
      addHsfpValid: false,
      intRules: [
        v => /^\d*$/.test(v) || 'The value must be an integer number'
      ]
    }
  },
  methods: {
    open(hsfp_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspt/hsfp/getHsfp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsfp"
          },
          getHsfp: {
            hsfp_encrid: hsfp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsfp = res.data.getHsfp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveHsfp() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/hsfp/saveHsfp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHsfp"
          },
          saveHsfp: {
            hsfp_encrid: this.hsfp.hsfp_encrid,
            hspt_encrid: this.hsfp.hspt_encrid,
            hsfp_advb: parseInt(this.hsfp.hsfp_advb),
            hsfp_inkoop: parseFloat(this.hsfp.hsfp_inkoop),
            hsfp_verkoop: parseFloat(this.hsfp.hsfp_verkoop)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            if (res.data.saveHsfp.color == "success")
               //this.$router.reload('/huis/hspt/hsfp/updHsfp/' + res.data.saveHsfp.hspt_encrid); 
               bus.$emit("closeDialog", "reload"); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHsfp.text,
              color: res.data.saveHsfp.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

